import React from 'react';
import styled from 'styled-components';

const TidalTextBoxWrapper = styled.div<{
  height: number;
}>`
  width: 100%;
  & > .label {
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    margin-bottom: 8px;
    color: ${(props) => props.theme.colors.text[0]};
  }
  & > textarea {
    height: 42px;
    border-radius: 10px;
    border: 1px solid ${(props) => props.theme.colors.borderColors[0]};
    background-color: ${(props) => props.theme.colors.secondary};
    padding: 10px 16px;
    width: 100%;
    &:focus {
      outline: 2px solid ${(props) => props.theme.colors.accent};
    }
    height: ${(props) => props.height}px;
  }
`;

interface ITidalTextBox {
  label: string;
  placeholder: string;
  height: number;
  value?: string;
  onChange?: (e: any) => void;
}

const TidalTextBox = ({
  label,
  placeholder,
  height,
  value,
  onChange,
}: ITidalTextBox): JSX.Element => {
  return (
    <TidalTextBoxWrapper height={height}>
      <p className="label">{label}</p>
      <textarea
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange && onChange(e)}
      />
    </TidalTextBoxWrapper>
  );
};

export default TidalTextBox;
